import { render, staticRenderFns } from "./StatusHistoryCard.vue?vue&type=template&id=10420006"
import script from "./StatusHistoryCard.vue?vue&type=script&lang=js"
export * from "./StatusHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./StatusHistoryCard.vue?vue&type=style&index=0&id=10420006&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports